import { Typography } from "@mui/material";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { styled, Box } from "@mui/system";
import { format, parseISO, isValid } from "date-fns";
import CustomSimpleCard from "@/components/custom/custom-simple-card";
import { useReportStats } from "@/hooks/use-report-stats";

const Grid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing(2),
}));

const formatLastGenerated = (date) => {
  if (!date) return "N/A";
  const parsed = parseISO(date);
  return isValid(parsed) ? format(parsed, "MMM d, yyyy") : "N/A";
};

const ReportStats = () => {
  const { stats, isLoading } = useReportStats();

  const cards = [
    {
      id: "total_reports",
      title: "Total Reports",
      value: stats.totalReports,
      icon: <AssignmentOutlinedIcon fontSize="small" />,
    },
    {
      id: "awaiting_approval",
      title: "Awaiting Approval",
      value: stats.awaitingApproval,
      icon: <HourglassEmptyOutlinedIcon fontSize="small" />,
    },
    {
      id: "scheduled_reports",
      title: "Scheduled",
      value: stats.scheduled,
      icon: <CalendarTodayOutlinedIcon fontSize="small" />,
    },
    {
      id: "last_generated",
      title: "Last Generated",
      value: formatLastGenerated(stats.lastGeneratedOn),
      subtitle: stats.lastGeneratedBy ? `by ${stats.lastGeneratedBy}` : null,
      icon: <RefreshOutlinedIcon fontSize="small" />,
    },
  ];

  return (
    <Grid>
      {cards.map((card) => (
        <CustomSimpleCard
          key={card.id}
          title={card.title}
          icon={card.icon}
          isLoading={isLoading}
        >
          <Typography
            fontWeight={400}
            fontSize={card.id === "last_generated" ? "1.4rem" : "2rem"}
            lineHeight={1.2}
          >
            {card.value}
          </Typography>
          {card.subtitle && (
            <Typography variant="caption" color="text.secondary">
              {card.subtitle}
            </Typography>
          )}
        </CustomSimpleCard>
      ))}
    </Grid>
  );
};

export default ReportStats;
